import { IManifest } from "../../model/manifest.interface";
import { Microservice } from "../../model/microservice";
import { BaseChainableBobComponent } from "../base-chainable-bob-component";
import { BaseChainableComponent } from "../pipeline/base-chainable-component";
import { IProcessable } from "../pipeline/processable.interface";

export class AssetLoaderComponent extends BaseChainableBobComponent<Microservice> implements IProcessable<Microservice> {

	public microservice: Microservice;

	public async process(input: Microservice) {

		this.microservice = input;
		this.microservice = this.addCssAssets(input, input.manifest);
		this.microservice = this.addJsAssets(input, input.manifest);

		return await this.next.process(input);
	}

	public addCssAssets(microservice: Microservice, manifest: IManifest) {

		if (manifest.assets.hasOwnProperty("css") && manifest.assets.css!.length > 0) {

			microservice.setCss(manifest.assets.css!);
		}

		return microservice;
	}

	public addJsAssets(microservice: Microservice, manifest: IManifest) {

		if (manifest.assets.hasOwnProperty("js") && manifest.assets.js!.length > 0) {

			microservice.setJs(manifest.assets.js!);
		}

		return microservice;
	}
}
